var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon02On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_3557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3335 38.1667V40.5H34.6668V38.1667H32.3335V35.8333H41.6668V19.5H18.3335V35.8333H27.6668V38.1667H25.3335ZM24.6327 27.9645V31.4787H26.4218V27.9645H24.6327ZM27.6146 25.4544V31.4787H29.4037V25.4544H27.6146ZM30.5965 26.9605V31.4787H32.3856V26.9605H30.5965ZM33.5784 23.9483V31.4787H35.3676V23.9483H33.5784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_3557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon02On);
export default __webpack_public_path__ + "static/media/leftmenu_icon02_on.cb2e0523b67ce805fd6f54e69ff2b05b.svg";
export { ForwardRef as ReactComponent };